import {app} from "../app";
import {IThemerService} from "../services/ThemerService";

class ThemerClassDirective implements ng.IDirective {

    protected themerService:IThemerService;

    restrict = 'A';

    constructor(ThemerService:IThemerService) {
        this.themerService = ThemerService;
    }

    link = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrl: any) => {
        if (!attrs['themerClass'] || attrs['themerClass'].length <= 0) {
            return;
        }

        let selectors = attrs['themerClass'].split(' ');
        for (let selectorName of selectors) {
            element.addClass('themer' + selectorName.charAt(0).toUpperCase() + selectorName.slice(1));
        }
    };

    static factory(): ng.IDirectiveFactory {
        const directive = (ThemerService:IThemerService) => new this(ThemerService);
        directive.$inject = ['ThemerService'];
        return directive;
    }

}

app.directive('themerClass', ThemerClassDirective.factory());